<div class="headerga">
  <div class="btnaddKey ui-btn ui-btn--primary">
    <i class="fas fa-plus"></i> Créer un nouvel accès
  </div>
  <div class="contCode">
    <div class="labCode">
      <i class="fa-regular fa-key"></i>&nbsp; Cl&eacute; d'acc&egrave;s :
    </div>
    <div class="valCode">
    </div>
  </div>
  <div class="cleanSearch"><i class="fa-solid fa-circle-xmark"></i></div>
  <input type="text" placeholder="Rechercher un acc&egrave;s" class="searchga searchBar">
  <div class="searchic"><i class="fal fa-search"></i></div>
</div>
<div class="headtabga">
  <div class="conthga">
    <div class="viHK">
    </div>
    <div class="nameHK">
      Nom
    </div>
    <div class="listHK">
      Listes
    </div>
    <div class="opHK">
    </div>
  </div>
</div>
<div class="contga">
  <div class="contitemga">
  </div>
</div>
<div class="contsearchResp">
  <input type="search" placeholder="Rechercher un acc&egrave;s" class="searchRespGa">
  <div class="searchicResp"><i class="fal fa-search"></i></div>
  <div class="cleanSearchResp"><i class="fa-solid fa-circle-xmark"></i></div>
</div>
<div class="txtnokey">
  Aucun acc&egrave;s n'a encore &eacute;t&eacute; configur&eacute;.
  <br><br>
  <span style="font-weight:800">Commencez par en cr&eacute;er en cliquant sur le bouton ci-dessus.</span>
</div>
<div class="txtnoterm">
  <i class="far fa-info-circle"></i> &nbsp;Aucun r&eacute;sultat trouv&eacute;.<br><br><span style="font-weight:800">R&eacute;essayer avec un autre mot cl&eacute;.</span>
</div>
<div class="blocedit blocedititemK">
  <div class="headedititemK">
    <span class="tithedaitemK" style="display:inline-block;"> &nbsp;<i class="fad fa-edit"></i> &nbsp;<span class="titheadTxt">Configuration de l'acc&egrave;s</span></span>
    <span class="closepopitemK"><i class="far fa-times"></i></span>
  </div>
  <div class="continopK">
    <!-- Section Device -->
    <div class="sectionDevice">
      <div class="interinK" style="margin-top:0px; border: none;">
        <i class="fa-duotone fa-light fa-input-text"></i> &nbsp; Nom
      </div>
      <div class="labelformitemK labnameK">Nom de l'acc&egrave;s</div><input class="inputformitemK inName" type="text" placeholder="ex : Entr&eacute;e nord" autocomplete="off">
      <div class="interinK">
        <i class="fa-duotone fa-light fa-key"></i> &nbsp; Acc&egrave;s
      </div>
      <div class="labelformitemK labidK">Identifiant</div><input class="inputformitemK inIdentifier" type="text" placeholder="Identifiant unique" autocomplete="username" data-lpignore="true">
      <br>
      <div class="labelformitemK labpassK">Mot de passe</div><input class="inputformitemK inPassword" type="password" placeholder="Mot de passe" autocomplete="new-password" data-lpignore="true">
      <br>
      <div class="labelformitemK labpassK">Cl&eacute; d'acc&egrave;s</div><div class="valCodePop"></div>
      <div class="interinK">
        <i class="fa-duotone fa-light fa-sliders"></i> &nbsp; Options
      </div>
      <div class="labelformitemK labmodoutK">Mode sortie</div>
      <div class="contcheckopK">
        <label class="ui-switch">
          <input type="checkbox" id="inmok" class="ui-switch__input">
          <span class="ui-switch__label labmok"></span>
        </label>
      </div>
      <br>
      <div class="labelformitemK labmodoutdefK">Sortie d&eacute;finitive</div>
      <div class="contcheckopK contcheckopdefK">
        <label class="ui-switch">
          <input type="checkbox" id="inmodefk" class="ui-switch__input">
          <span class="ui-switch__label labmodefk"></span>
        </label>
      </div>
      <br>
      <div class="labelformitemK labadminK">Administrateur</div>
      <div class="contcheckopK">
        <label class="ui-switch">
          <input type="checkbox" id="inadmink" class="ui-switch__input">
          <span class="ui-switch__label labadmink"></span>
        </label>
      </div>
    </div>
    <!-- Section BO -->
    <div class="sectionBo">
      <div class="interinK" style="margin-top:0px; border: none;">
        <i class="fa-duotone fa-light fa-user"></i> &nbsp; Informations
      </div>
      <div class="labelformitemK">Email</div><input class="inputformitemK inEmailBo" type="email" placeholder="email@exemple.com" autocomplete="off">
      <br>
      <div class="labelformitemK">Mot de passe</div><input class="inputformitemK inPasswordBo" type="password" placeholder="Mot de passe" autocomplete="new-password">
      <br>
      <div class="labelformitemK">Pr&eacute;nom</div><input class="inputformitemK inFirstnameBo" type="text" placeholder="Pr&eacute;nom" autocomplete="off">
      <br>
      <div class="labelformitemK">Nom</div><input class="inputformitemK inLastnameBo" type="text" placeholder="Nom" autocomplete="off">
      <div class="interinK">
        <i class="fa-duotone fa-light fa-browser"></i> &nbsp; Pages autoris&eacute;es
      </div>
      <div class="contPagesBoK">
        <div class="liLK liPageBoK" data-page="tableau-de-bord" mod0="checked" mod1="checked"><div class="contCheckLK"><input type="checkbox" class="inCheckLK inCheckPageBo" checked><label class="labCheckLK"><i class="fas fa-check icCheckLK"></i></label></div><div class="nameLK">Tableau de bord</div></div>
        <div class="liLK liPageBoK" data-page="liste-des-participants" mod0="checked" mod1="checked"><div class="contCheckLK"><input type="checkbox" class="inCheckLK inCheckPageBo" checked><label class="labCheckLK"><i class="fas fa-check icCheckLK"></i></label></div><div class="nameLK">Liste des participants</div></div>
        <div class="liLK liPageBoK" data-page="configurer-general" mod0="" mod1=""><div class="contCheckLK"><input type="checkbox" class="inCheckLK inCheckPageBo"><label class="labCheckLK"><i class="fas fa-check icCheckLK"></i></label></div><div class="nameLK">Configurer (g&eacute;n&eacute;ral)</div></div>
        <div class="liLK liPageBoK" data-page="configurer-ma-liste" mod0="" mod1=""><div class="contCheckLK"><input type="checkbox" class="inCheckLK inCheckPageBo"><label class="labCheckLK"><i class="fas fa-check icCheckLK"></i></label></div><div class="nameLK">Configurer (ma liste)</div></div>
        <div class="liLK liPageBoK" data-page="gerer-les-acces" mod0="" mod1=""><div class="contCheckLK"><input type="checkbox" class="inCheckLK inCheckPageBo"><label class="labCheckLK"><i class="fas fa-check icCheckLK"></i></label></div><div class="nameLK">G&eacute;rer les acc&egrave;s</div></div>
        <div class="liLK liPageBoK" data-page="parametres" mod0="" mod1=""><div class="contCheckLK"><input type="checkbox" class="inCheckLK inCheckPageBo"><label class="labCheckLK"><i class="fas fa-check icCheckLK"></i></label></div><div class="nameLK">Param&egrave;tres</div></div>
        <div class="liLK liPageBoK" data-page="aide" mod0="checked" mod1="checked"><div class="contCheckLK"><input type="checkbox" class="inCheckLK inCheckPageBo" checked><label class="labCheckLK"><i class="fas fa-check icCheckLK"></i></label></div><div class="nameLK">Aide</div></div>
        <div class="liLK liPageBoK" data-page="support" mod0="checked" mod1="checked"><div class="contCheckLK"><input type="checkbox" class="inCheckLK inCheckPageBo" checked><label class="labCheckLK"><i class="fas fa-check icCheckLK"></i></label></div><div class="nameLK">Support</div></div>
      </div>
    </div>
  </div>
  <div class="contconflistK">
    <div class="labelast"> <i class="fa-duotone fa-clipboard-check"></i> &nbsp;<span class="txtlabelast">Listes de contr&ocirc;le</span>&nbsp; <i class="fa-solid fa-chevron-up iclistk"></i><div class="countLK">0 / 0</div></div>
    <div class="searchListK"><input type="text" class="inSearchListK" placeholder="Rechercher une liste..." autocomplete="off"><i class="fa-light fa-search icSearchListK"></i></div>
    <div class="conflistK">
    </div>
  </div>
  <div class="maskcclitk">
  </div>
  <div class="btnvalidedititemK btnvalidedititemKOff ui-btn ui-btn--primary ui-btn--block"><i class="fa-solid fa-floppy-disk"></i> &nbsp; <span class="txtbtnvalidedititemK">Enregister</span></div>
</div>
<div class="popTypeAccess" role="dialog" aria-labelledby="titleTypeAccess">
  <div class="contTypeAccess">
    <div class="headpopTypeAccess" id="titleTypeAccess">
      Quel type d'acc&egrave;s souhaitez-vous cr&eacute;er ?
    </div>
    <div class="choixTypeAccess">
      <button type="button" class="btnTypeDevice ui-btn ui-btn--primary ui-btn--block" data-testid="access-type-device" aria-describedby="subTypeDevice">
        <i class="fa-duotone fa-mobile-screen" aria-hidden="true"></i> Acc&egrave;s Device
      </button>
      <div class="subtxtType" id="subTypeDevice">Scan via l'application Wilout Control</div>
    </div>
    <div class="choixTypeAccess">
      <button type="button" class="btnTypeBo ui-btn ui-btn--primary ui-btn--block" data-testid="access-type-bo" aria-describedby="subTypeBo">
        <i class="fa-duotone fa-desktop" aria-hidden="true"></i> Acc&egrave;s Back-office
      </button>
      <div class="subtxtType" id="subTypeBo">Connexion au BO Control via email</div>
    </div>
  </div>
</div>
<div class="fdpopedit">
</div>
<div class="popmax">
  <div class="headpopmax">
    Maximum atteint
  </div>
  <div class="txtpopmax">
    <i class="fal fa-info-circle" style="font-size:40px"></i>
    <br><br>
    Vous avez atteint le nombre maximum
    <br>
    d'acc&egrave;s autoris&eacute;s pour cet &eacute;v&eacute;nement
  </div>
  <div class="btnpopmax ui-btn ui-btn--secondary ui-btn--auto">
    OK
  </div>
</div>
<div class="popInfoCode">
  <div style="width:100%; text-decoration: underline; font-weight: 800;">Cl&eacute; secr&egrave;te d'acc&egrave;s</div>
  <div style="width:100%; margin-top: 10px;">
    Cette cl&eacute; permet de s'identifier lors de la connexion &agrave; l'un de vos point d'acc&egrave;s.
    <br>
    Il doit &ecirc;tre renseign&eacute; dans le champs "Cl&eacute; d'acc&egrave;s" sur l'app Wilout Control.
  </div>
</div>
